import { type AwinFields, JOGGResponse } from "@jog/types"

import { getTwProfilekey } from "../../localStorage"
import { JoggApiOption } from "../client"

export interface BuckarooCheckoutParams {
    cartId: string
    paymentMethod: string
    birthDate?: string | null
    phoneNumber?: string | null
    bankIssuer?: string | null
    customerCardName?: string | null
    paymentData?: string | null
    pin?: string | null
    additionalPayment?: string | null
    awin?: AwinFields
}

export interface BuckarooCheckoutResponse {
    RedirectUrl: string
    orderId: string
    isVoucherValid: boolean
    voucherCode: string
    code: number
    subCode: number
    message: string
    errCode?: "001" | "002"
}

export const buckarooCheckoutBase = ({ client, setToken }: Pick<JoggApiOption, "client" | "setToken">) => {
    return async <T extends JOGGResponse<BuckarooCheckoutResponse>>({
        paymentMethod,
        bankIssuer,
        ...data
    }: BuckarooCheckoutParams): Promise<T> => {
        const profileKey = getTwProfilekey()
        const requestWithToken = await setToken({
            method: "POST",
            uri: "/orders/v1/payment",
            body: Object.assign({ provider: paymentMethod }, data, bankIssuer ? { bankIssuer } : {}, {
                callback: `${window.location.origin}/api/payment/redirect`,
            }),
            headers: profileKey ? { ["x-tw-profilekey"]: profileKey } : {},
        })
        return client.execute(requestWithToken)
    }
}
